import {VscodeIcon} from '@primer/octicons-react'
import styles from './CliIcon.module.css'

interface VscodeSessionIconProps {
  showConnectedDot?: boolean
}

export function VscodeSessionIcon({showConnectedDot = false}: VscodeSessionIconProps) {
  const ariaLabel = showConnectedDot ? 'VS Code session connected' : 'VS Code session'

  return (
    <span className={styles.wrapper} role="img" aria-label={ariaLabel}>
      <VscodeIcon />
      {showConnectedDot && <span data-testid="connected-dot" className={styles.connectedDot} aria-hidden="true" />}
    </span>
  )
}
